import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})
export class AppComponent {

    public showHeader = true;
    public showFooter = true;

    public isInnerPage = false;

constructor(private router: Router) {
    router.events.subscribe((route:any) => this.viewLayout(route));
}

public viewLayout(route:any) {
    //console.log(route);
    if(route instanceof NavigationEnd) {
        if(route.urlAfterRedirects.startsWith("/admin/login") || route.urlAfterRedirects.startsWith("/default")) {
            this.showFooter = false;
            this.showHeader = false;
            this.isInnerPage = false;
        }
        else {
            this.showFooter = true;
            this.showHeader = true;
            if(!route.urlAfterRedirects.startsWith("/admin/home")) {
                this.isInnerPage = true;
            }
            else {
                this.isInnerPage = false;
            }
        }
    }
}


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/app/app.component.ts